<template>
  <Grid class="emails-table body bg-white-1 q-pl-md q-pr-lg q-py-lg">
    <q-inner-loading :showing="loading" style="z-index: 1">
      <q-spinner color="secondary-1" size="2rem" />
    </q-inner-loading>

    <AgGrid
      v-if="showTable"
      ref="agGrid"
      :header-height="48"
      :options="gridOptions"
      :api-request="infiniteScrollRequest"
      :context="context"
      class="q-px-sm"
      style="grid-template-rows: 1fr"
      @ready="onGridReady"
      @export-loading="setExportLoading"
    >
    </AgGrid>
  </Grid>
</template>

<script>
import * as apiTo from '@/modular-api'
// Mixins
import { exportToExcel } from '@/mixins/export-to-excel'
import gridOptionsMixin from './gridOptions'
// Libraries
import { mapState, mapMutations, mapActions } from 'vuex'
// Components
import AgGrid from '@/ag-grid/AgGrid'

export default {
  components: {
    AgGrid
  },

  mixins: [exportToExcel, gridOptionsMixin],

  data: () => ({
    agGrid: null,
    showTable: false,
    context: {}
  }),

  computed: {
    ...mapState('lv-emails', ['loading', 'tableState'])
  },

  async created() {
    await this.getAndSetTableState()
    this.showTable = true
    this.context = { parentCmp: this }
  },

  beforeDestroy() {
    this.storeTableState()
    this.$store.dispatch('lv-emails/saveTableState')
  },

  methods: {
    ...mapMutations('lv-emails', ['setLoading', 'setExportLoading']),
    ...mapActions('lv-emails', ['getAndSetTableState']),

    infiniteScrollRequest(request) {
      return apiTo.GET_PAGINATED_EMAILS(request)
    },

    onGridReady(agGrid) {
      this.agGrid = agGrid
      this.$emit('ag-grid', agGrid)
      this.tableState.filter && this.agGrid.api.setFilterModel(this.tableState.filter)
      this.tableState.columns && this.agGrid.columnApi.setColumnState(this.tableState.columns)
    },

    storeTableState() {
      const filterModel = this.agGrid.api.getFilterModel()
      const columnState = this.agGrid.columnApi.getColumnState()

      this.$store.commit('lv-emails/setTableStateFilter', filterModel)
      this.$store.commit('lv-emails/setTableStateColumns', columnState)
    },

    exportToExcel() {
      this.agGrid.api.exportDataAsExcel({
        fileName: 'Emails Outbox',
        sheetName: 'Roam',
        columnKeys: ['created_at', 'subject', 'from', 'to', 'has_attachments']
      })
    }
  }
}
</script>
